export const searchBoxStyles = {
    height: "38px",
    minWidth: "280px",
    color: "#3E3F4CB2",
    fontWeight: 400,
    fontSize: "15px",
    background: "#FFFF",
  
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#EAEAEA" },
  
      "&:hover fieldset": {
        borderColor: "#46a091",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#46a091",
      },
    },
  };